<template>
    <el-dialog class="dialog-Coupon" title="选择优惠券" :visible.sync="isShow" :before-close="beforeClose">
        <div>
            <el-table ref="singleTable" :data="couponList" style="width: 100%" highlight-current-row
                @current-change="handleChange">
                <el-table-column align="center" prop="title" label="优惠券名称"></el-table-column>
                <el-table-column align="center" prop="price" label="优惠券金额">
                    <template slot-scope="scope">满{{ scope.row.minUsePrice }}减{{ scope.row.price }}</template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页器 -->
        <div class="pagination">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
                layout="total, prev, pager, next, jumper" :total="pageTotal">
            </el-pagination>
        </div>

        <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="beforeClose">取 消</el-button> -->
            <el-button type="primary" @click="confirmChoose">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
//这里可以导入其他文件（比如：Api，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》'
import { getCashCouponList } from "../api/index";

export default {
    components: {},
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            pageTotal: 0,

            couponList: [],

            currentCoupon: {},
        };
    },
    computed: {},
    watch: {},
    mounted() {
        this.getData();
    },

    methods: {
        async getData() {
            try {
                const tempData = {
                    pageNumber: this.currentPage,
                    row: this.pageSize,
                    isEnable: 1,
                    batchOrderType: 0,
                    isEnable: 1,
                    filterExpire: 1,
                }
                const res = await getCashCouponList(tempData);

                if (res.code == 1) {
                    this.couponList = res.data.pager.list || [];
                    this.pageTotal = res.data.pager.totalCount || 0;
                }
                console.log(res);
            } catch (error) {
                console.log(error);
            }
        },

        handleChange(val) {
            this.currentCoupon = val;
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.getData();
        },

        confirmChoose() {
            this.$emit("confirmCoupon", this.currentCoupon);
        },

        beforeClose() {
            this.$emit("hideDialogCoupon");
        },
    },
};
</script>

<style lang="less" scoped>
.pagination {
    display: flex;
    justify-content: center;
    width: 100%;

    background-color: #fff;

    margin-top: 10px;
}

.el-pagination::v-deep {
    padding: 5px 0;
}
</style>